module.exports = __webpack_public_path__ + "img/crx-main-logo-1.79e5dc5c.png";